import axios from "axios";
import { msalInstance } from "../index";
import { loginRequest } from "../auth/authConfig";

const instance = axios.create({
  timeout: 60000,
  responseType: "json",
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  async (config) => {
    const account =
      msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];

    if (account) {
      try {
        const result = await msalInstance.acquireTokenSilent({
          ...loginRequest,
          account,
        });
        config.headers = {
          ...(config.headers || {}),
          Authorization: `Bearer ${result.idToken}`,
        };
      } catch (e) {
        console.error("Token acquisition failed:", e);
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
    }
    return Promise.reject(error);
  }
);

const Api = {
  post(path, body, url = "") {
    const baseURL = window.backendURL
      ? window.backendURL
      : process.env.REACT_APP_API_URL;

    const headers = {};
    if (path) headers.path = `/${process.env.REACT_APP_API_PATH}/_proc/${path}`;

    return instance.post(url, body, {
      baseURL, 
      headers, 
    });
  },

  get(url) {
    const baseURL = window.backendURL
      ? window.backendURL
      : process.env.REACT_APP_API_URL;

    return instance.get(url, { baseURL });
  },
};

export default Api;


